import React, { useState } from 'react'
import { useTranslator } from '@/hooks'
import { Button, DialogContent, Typography, Drawer, Tabs, Tab, Box, DialogTitle, Divider } from '@mui/material'
import ImportEmployeeFileForm from './ImportEmployeeFileForm'
import { EmployeeManualForm } from './employee/EmployeeManualForm'

export function CreateEmployeeDrawer({ open, setOpen, onSuccess, companyId, businessNumber }: any) {
  const { __ } = useTranslator()
  const [tabValue, setTabValue] = useState(0)

  const handleClose = () => {
    setOpen(false)
  }

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      closeAfterTransition={false}
      anchor='right'
      variant='temporary'
      sx={{
        '& .MuiDrawer-paper': {
          width: {
            xs: tabValue === 0 ? 370 : 740,
            sm: tabValue === 0 ? 370 : 740,
            md: tabValue === 0 ? 370 : 740
          }
        }
      }}
    >
      <DialogTitle className='flex justify-between items-center p-4'>
        <Typography className='text-[18px] leading-[28px] font-medium'>{__('Add Employee')}</Typography>
        <Button className='w-6 h-6' onClick={handleClose} variant='text' color='inherit'>
          <i className='tabler-x w-6 h-6' />
        </Button>
      </DialogTitle>
      <Divider />
      <DialogContent className='p-6'>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label='employer creation tabs' className='mb-4'>
            <Tab
              icon={<i className='tabler-file-upload' />}
              iconPosition='start'
              label={__('Import File')}
              className='w-1/2'
            />
            <Tab icon={<i className='tabler-user' />} iconPosition='start' label={__('Manual')} className='w-1/2' />
          </Tabs>

          {tabValue === 0 && <ImportEmployeeFileForm onClose={handleClose} refetch={onSuccess} companyId={companyId} businessNumber={businessNumber} />}
          {tabValue === 1 && <EmployeeManualForm onClose={handleClose} refetch={onSuccess} companyId={companyId || null} />}
        </Box>
      </DialogContent>
    </Drawer>
  )
}
